export default "__VITE_ASSET__DntowsO2__"